import { Box, Grid, Skeleton } from "@mui/material";

const NotificationInfoSkeleton = () => {
  return (
    <Box>
      <Box
        sx={{
          boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
          margin: "10px",
          backgroundColor: "#fff",
          borderRadius: 1,
          mx:3
        }}
      >
        <Box sx={{ p: 3, paddingBottom: "15px" }}>
          {[...Array(1)].map((_, index) => (
            <Grid container spacing={2} key={index}>
              <Grid item xs={4}>
                <Box sx={{ display: "flex", flexDirection: "column"}}>
                  <Skeleton variant="text" width="100%" height={55}  />
                  <Skeleton variant="text" width="100%" height={120} />
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Skeleton variant="text" width="100%" height={55}  />
                  <Skeleton variant="text" width="100%" height={120}  />
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Skeleton variant="text" width="100%" height={55}  />
                  <Skeleton variant="text" width="100%" height={120}  />
                </Box>
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "end", width: "100%" }}>
                <Skeleton variant="rectangular" width={170} height={37} sx={{ marginRight: "10px" , borderRadius:5 }} />
                <Skeleton variant="rectangular" width={90} height={37} sx={{ borderRadius:5 }}/>
              </Box>
            </Grid>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationInfoSkeleton;
